/**
 * Схема для visibilityConditions
 * Расположена в shared слое для использования в PlatformBlocks и других компонентах
 * Использует строковые литералы вместо enum из admin для соблюдения архитектуры
 */

// Маппинг значений на читаемые лейблы для userType
export const usersTypes: Record<string, string> = {
  NONE: "Никому",
  GUEST: "Только гостям",
  USER: "Только зарегистрированным",
  ADMIN: "Только администраторам",
  ALL: "Всем",
};

// Маппинг значений на читаемые лейблы для типа доступа платформ
export const platformsAccessTypes: Record<string, string> = {
  INCLUDE: "Включая",
  EXCLUDE: "Исключая",
  ALL: "Все",
};

// Маппинг значений на читаемые лейблы для платформ
export const platformsTypes: Record<string, string> = {
  IOS: "IOS",
  ANDROID: "ANDROID",
  WEB: "WEB",
};

// Маппинг значений на читаемые лейблы для типа доступа стран
export const countriesAccessTypes: Record<string, string> = {
  INCLUDE: "Включая",
  EXCLUDE: "Исключая",
  ALL: "Все",
};

/**
 * Ключи переводов для лейблов опций видимости.
 *
 * Сами мапы выше остаются словарём русских подписей: он служит и списком
 * допустимых значений, и значением по умолчанию для админки, где ключей
 * `visibility.*` в словаре нет. Партнёрский кабинет резолвит их из namespace
 * `partner` (сид `backend/src/migrations/data/partnerSeed/platformCore.ts`).
 */
export const VISIBILITY_LABEL_KEYS = {
  usersTypes: "visibility.userType",
  platformsAccessTypes: "visibility.platformsAccessType",
  countriesAccessTypes: "visibility.countriesAccessType",
} as const;
